import { PAGES } from "@/common/consts";

export default {
	computed: {
		isGetTheAppPage() {
			return this.$route.name === PAGES.GET_THE_APP;
		},
	},
};
